const Footer = () => {
  return (
    <div
      style={{
        bottom: 0,
        position: 'fixed',
        width: '100vw',
        paddingBottom: '10px',
        zIndex: '999',
        display: 'flex',
      }}
    >
      <h5 className="new-footer-text">Copyright © 2023, sdmusicgroup</h5>
    </div>
  );
};

export default Footer;
